<template>
  <div class="vw-100 vh-100 row g-0">
    <div class="position-absolute top-0 start-0 text-light px-1">
      {{ version }}
    </div>
    <div class="col-12 col-sm-4 col-lg-3 col-xl-2 bg-primary p-3">
      <div class="d-flex flex-column h-100">
        <MainLogo/>
        <div class="flex-grow-1 mt-3">
          <div>
            <label class="form-label mb-0 text-light">Email</label>
            <input name="email" type="text" class="form-control" v-model="email">
            <form-error-login name="email" :errors="errors" class="mt-1"></form-error-login>
          </div>
          <div>
            <label class="form-label mb-0 text-light">Contraseña</label>
            <input name="password" type="password" class="form-control" v-model="password"
                   @keyup.enter="login">
            <form-error-login name="password" :errors="errors" class="mt-1"></form-error-login>
          </div>
          <div class="text-center">
            <button :disabled="working"
                    class="btn btn-outline-light w-100 my-3" @click="login">
              Iniciar sesión
            </button>
            <span class="">
              <router-link to="/recuperarContrasena" class="link-light">¿Olvidaste tu contraseña?</router-link>
            </span>
          </div>
        </div>
        <div class="p-3 dev-by">
          <img src="../assets/dev_by_white.png" class="w-100">
        </div>
      </div>

    </div>
    <LoginBanner/>
  </div>
</template>

<script>
import axios from "axios";
import FormErrorLogin from "../components/utils/FormErrorLogin.vue";
import {VERSION} from '../code/app';
import {mapState} from "pinia";
import {useUserStore} from "../stores/user";
import MainLogo from "../components/home/MainLogo.vue";
import LoginBanner from "../components/home/LoginBanner.vue";

export default {
  name: 'LoginView',
  components: {
    LoginBanner,
    MainLogo,
    FormErrorLogin
  },
  data() {
    return {
      project_name: import.meta.env.VITE_NAME ?? 'Tresfactorial',
      errors: {},
      email: null,
      password: null,
      working: false,
      version: VERSION,
    }
  },
  methods: {
    login() {
      this.errors = [];
      this.working = true;
      axios.post('/login', {
        email: this.email,
        password: this.password,
      }).then(response => {
        this.$router.replace('/');
      }).catch(error => {
        this.errors = error?.response?.data?.errors ?? {};
        this.working = false;
      });
    }
  }
}
</script>
